import { render, staticRenderFns } from "./downplico.vue?vue&type=template&id=5778f8e8&"
import script from "./downplico.vue?vue&type=script&lang=js&"
export * from "./downplico.vue?vue&type=script&lang=js&"
import style0 from "./downplico.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports